import './BASK.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class BASK extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.initEstimateShipping();
		this.initQuantify();
		this.initRestoreLinks();
		this.initPromoCodeEvents();
		this.initCouponForms();
	}

	async initCouponForms () {
		const couponForms = document.getElementsByClassName('g-checkout__order-summary-promo-form');

		if (!couponForms.length) {
			return;
		}

		const {HTMLFormValidator} = await import('extensions/form-validation');

		for (const form of couponForms) {
			new HTMLFormValidator({
				errorInsertPosition: 'afterend',
				fieldContainer: '.g-checkout__order-summary-promo-form-fields',
				formElement: form
			});
		}
	}

	async initEstimateShipping () {
		const shippingEstimateForm = document.getElementById('js-shipestimate-form');

		if (!shippingEstimateForm) {
			return;
		}

		const {default: ShippingEstimator} = await import('extensions/shipping-estimator');

		new ShippingEstimator(shippingEstimateForm);
	}

	async initQuantify () {
		const forms = document.getElementsByClassName('js-basket-form-update');

		if (forms.length === 0) {
			return;
		}

		const {Quantify} = await import('extensions/quantify');

		for (const form of forms) {
			new Quantify({
				formElement: form,
				wrapper: form.querySelector('[data-hook="quantify"]')
			});
		}
	}

	initRestoreLinks () {
		// Disable subsequent clicks on restore links
		const restoreLinks = document.getElementsByClassName('js-restore-link');

		if (!restoreLinks.length) {
			return;
		}

		for (const link of restoreLinks) {
			link.addEventListener('click', () => {
				link.style.pointerEvents = 'none';
			});
		}
	}

	async initPromoCodeEvents () {

		const promoCodeContainers = document.getElementsByClassName('g-checkout__order-summary-promo-form');

		if (!promoCodeContainers.length) {
			return;
		}

		const {PromoCodeEvents} = await import('extensions/checkout-pages');

		for (const promoCodeContainer of promoCodeContainers) {
			const input = promoCodeContainer.querySelector('input[type=text]');
			const submitElement = promoCodeContainer.querySelector('[type=submit]');

			if (input && submitElement) {
				new PromoCodeEvents(input, submitElement);
			}
		}

	}

}
